import { graphql } from '@/__generated__';
import { SelectorPart } from '@/__generated__/graphql';
import { useQueryStable } from '../useQueryStable';

export type AutocompleteSelectorResponse = NonNullable<
  ReturnType<typeof useDiscoveryAutocompleteSelector>[0]['data']
>;

export type ResponseAutocompleteNode<TSelectorPart = SelectorPart> = {
  hit: string;
  type: TSelectorPart | SelectorPart;
};

export const GetAutocompleteSelector = graphql(/* GraphQL */ `
  query AutocompleteSelector($environmentId: BigInt!, $selector: String!) {
    environment(id: $environmentId) {
      selectorAutocomplete(selector: $selector) {
        completion
        display
        description
        type
      }
    }
  }
`);

type AutocompleteSelectorParams = {
  environmentId: number | undefined;
  selector: string | null;
  pause?: boolean;
};

export const useDiscoveryAutocompleteSelector = ({
  environmentId = 0,
  selector,
  pause,
}: AutocompleteSelectorParams) => {
  return useQueryStable({
    query: GetAutocompleteSelector,
    variables: { environmentId, selector: selector! },
    pause: pause || selector == null || !environmentId,
  });
};
